module.exports = __webpack_public_path__ + "img/404-error.05093d7c.svg";